//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_DASHBOARD_API_BASE_URL = new InjectionToken<string>('OM_DASHBOARD_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class OrderManagementDashboard extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_DASHBOARD_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getOrdersByStatusByMonthData(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrdersByStatusByMonthData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrdersByStatusByMonthData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersByStatusByMonthData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfChartDataResponseDto>;
        }));
    }

    protected processGetOrdersByStatusByMonthData(response: HttpResponseBase): Observable<AjaxResponseOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getBIWeeklyOrdersData(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBIWeeklyOrdersData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBIWeeklyOrdersData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBIWeeklyOrdersData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
        }));
    }

    protected processGetBIWeeklyOrdersData(response: HttpResponseBase): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getBIWeeklyOrdersDetails(request: OrderFilterDto | null | undefined): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBIWeeklyOrdersDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBIWeeklyOrdersDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBIWeeklyOrdersDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
        }));
    }

    protected processGetBIWeeklyOrdersDetails(response: HttpResponseBase): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfSimpleOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getBIWeeklyOrdersDetailsByRejectionReasonType(request: OrderFilterDto | null | undefined): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBIWeeklyOrdersDetailsByRejectionReasonType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBIWeeklyOrdersDetailsByRejectionReasonType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBIWeeklyOrdersDetailsByRejectionReasonType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
        }));
    }

    protected processGetBIWeeklyOrdersDetailsByRejectionReasonType(response: HttpResponseBase): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfSimpleOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getWeeklyOrderVolumeTrendsData(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetWeeklyOrderVolumeTrendsData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWeeklyOrderVolumeTrendsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyOrderVolumeTrendsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfChartDataResponseDto>;
        }));
    }

    protected processGetWeeklyOrderVolumeTrendsData(response: HttpResponseBase): Observable<AjaxResponseOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrderSLAStatus(): Observable<AjaxResponseOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrderSLAStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderSLAStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSLAStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfChartDataResponseDto>;
        }));
    }

    protected processGetOrderSLAStatus(response: HttpResponseBase): Observable<AjaxResponseOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param missingSlaType (optional) 
     * @return Success
     */
    getOrdersBySLAType(missingSlaType: string | null | undefined): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrdersBySLAType?";
        if (missingSlaType !== undefined && missingSlaType !== null)
            url_ += "missingSlaType=" + encodeURIComponent("" + missingSlaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrdersBySLAType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersBySLAType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
        }));
    }

    protected processGetOrdersBySLAType(response: HttpResponseBase): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfSimpleOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getWeeklyCommunicationVolumeTrendsData(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetWeeklyCommunicationVolumeTrendsData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWeeklyCommunicationVolumeTrendsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyCommunicationVolumeTrendsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
        }));
    }

    protected processGetWeeklyCommunicationVolumeTrendsData(response: HttpResponseBase): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getMonthlySVLVolumeTrends(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetMonthlySVLVolumeTrends";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMonthlySVLVolumeTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlySVLVolumeTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
        }));
    }

    protected processGetMonthlySVLVolumeTrends(response: HttpResponseBase): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getSvlsResponsesOverTime(request: ChartFilterDto | null | undefined): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetSvlsResponsesOverTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSvlsResponsesOverTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSvlsResponsesOverTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfChartDataResponseDto>;
        }));
    }

    protected processGetSvlsResponsesOverTime(response: HttpResponseBase): Observable<AjaxResponseOfListOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getSvlsResponseDetails(request: DashboardCommunicationFilterDto | null | undefined): Observable<AjaxResponseOfListOfDashboardCommunicationSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetSvlsResponseDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSvlsResponseDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSvlsResponseDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfDashboardCommunicationSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfDashboardCommunicationSummaryDto>;
        }));
    }

    protected processGetSvlsResponseDetails(response: HttpResponseBase): Observable<AjaxResponseOfListOfDashboardCommunicationSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfDashboardCommunicationSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrdersPastStatusTimeThresholdData(): Observable<AjaxResponseOfChartDataResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrdersPastStatusTimeThresholdData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrdersPastStatusTimeThresholdData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersPastStatusTimeThresholdData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfChartDataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfChartDataResponseDto>;
        }));
    }

    protected processGetOrdersPastStatusTimeThresholdData(response: HttpResponseBase): Observable<AjaxResponseOfChartDataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfChartDataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional) 
     * @param orderStatusId (optional) 
     * @return Success
     */
    searchOrdersPastStatusTimeThresholdDateList(programId: string | null | undefined, orderStatusId: string | null | undefined): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/SearchOrdersPastStatusTimeThresholdDateList?";
        if (programId !== undefined && programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (orderStatusId !== undefined && orderStatusId !== null)
            url_ += "orderStatusId=" + encodeURIComponent("" + orderStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchOrdersPastStatusTimeThresholdDateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOrdersPastStatusTimeThresholdDateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfSimpleOrderDto>;
        }));
    }

    protected processSearchOrdersPastStatusTimeThresholdDateList(response: HttpResponseBase): Observable<AjaxResponseOfListOfSimpleOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfSimpleOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ChartFilterDto implements IChartFilterDto {
    programId: string | undefined;
    month: number | undefined;
    year: number | undefined;
    periodicStartDate: Date | undefined;
    periodicEndDate: Date | undefined;
    tenantId: number | undefined;
    programName: string | undefined;

    constructor(data?: IChartFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.periodicStartDate = _data["periodicStartDate"] ? new Date(_data["periodicStartDate"].toString()) : <any>undefined;
            this.periodicEndDate = _data["periodicEndDate"] ? new Date(_data["periodicEndDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.programName = _data["programName"];
        }
    }

    static fromJS(data: any): ChartFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["month"] = this.month;
        data["year"] = this.year;
        data["periodicStartDate"] = this.periodicStartDate ? this.periodicStartDate.toISOString() : <any>undefined;
        data["periodicEndDate"] = this.periodicEndDate ? this.periodicEndDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["programName"] = this.programName;
        return data;
    }

    clone(): ChartFilterDto {
        const json = this.toJSON();
        let result = new ChartFilterDto();
        result.init(json);
        return result;
    }
}

export interface IChartFilterDto {
    programId: string | undefined;
    month: number | undefined;
    year: number | undefined;
    periodicStartDate: Date | undefined;
    periodicEndDate: Date | undefined;
    tenantId: number | undefined;
    programName: string | undefined;
}

export class AjaxResponseOfChartDataResponseDto implements IAjaxResponseOfChartDataResponseDto {
    result: ChartDataResponseDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfChartDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ChartDataResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfChartDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfChartDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfChartDataResponseDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfChartDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfChartDataResponseDto {
    result: ChartDataResponseDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ChartDataResponseDto implements IChartDataResponseDto {
    data: ChartDataDtoOfInt32 | undefined;

    constructor(data?: IChartDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChartDataDtoOfInt32.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChartDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }

    clone(): ChartDataResponseDto {
        const json = this.toJSON();
        let result = new ChartDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IChartDataResponseDto {
    data: ChartDataDtoOfInt32 | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ChartDataDtoOfInt32 implements IChartDataDtoOfInt32 {
    labels: ChartLabelsDto | undefined;
    datasets: ChartDataSetDtoOfInt32[] | undefined;

    constructor(data?: IChartDataDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labels = _data["labels"] ? ChartLabelsDto.fromJS(_data["labels"]) : <any>undefined;
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets.push(ChartDataSetDtoOfInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartDataDtoOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labels"] = this.labels ? this.labels.toJSON() : <any>undefined;
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        return data;
    }

    clone(): ChartDataDtoOfInt32 {
        const json = this.toJSON();
        let result = new ChartDataDtoOfInt32();
        result.init(json);
        return result;
    }
}

export interface IChartDataDtoOfInt32 {
    labels: ChartLabelsDto | undefined;
    datasets: ChartDataSetDtoOfInt32[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class ChartLabelsDto implements IChartLabelsDto {
    labels: ChartLabelDto[] | undefined;
    readonly dataMode: string | undefined;

    constructor(data?: IChartLabelsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels.push(ChartLabelDto.fromJS(item));
            }
            (<any>this).dataMode = _data["dataMode"];
        }
    }

    static fromJS(data: any): ChartLabelsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartLabelsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["dataMode"] = this.dataMode;
        return data;
    }

    clone(): ChartLabelsDto {
        const json = this.toJSON();
        let result = new ChartLabelsDto();
        result.init(json);
        return result;
    }
}

export interface IChartLabelsDto {
    labels: ChartLabelDto[] | undefined;
    dataMode: string | undefined;
}

export class ChartDataSetDtoOfInt32 implements IChartDataSetDtoOfInt32 {
    label: string | undefined;
    id: string | undefined;
    data: number[] | undefined;
    stack: string | undefined;

    constructor(data?: IChartDataSetDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.id = _data["id"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(item);
            }
            this.stack = _data["stack"];
        }
    }

    static fromJS(data: any): ChartDataSetDtoOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataSetDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["id"] = this.id;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["stack"] = this.stack;
        return data;
    }

    clone(): ChartDataSetDtoOfInt32 {
        const json = this.toJSON();
        let result = new ChartDataSetDtoOfInt32();
        result.init(json);
        return result;
    }
}

export interface IChartDataSetDtoOfInt32 {
    label: string | undefined;
    id: string | undefined;
    data: number[] | undefined;
    stack: string | undefined;
}

export class ChartLabelDto implements IChartLabelDto {
    label: string | undefined;
    id: string | undefined;
    code: string | undefined;
    startDateTime: Date | undefined;
    endDateTime: Date | undefined;
    dateTime: Date | undefined;
    paramValue: string | undefined;

    constructor(data?: IChartLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.id = _data["id"];
            this.code = _data["code"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.paramValue = _data["paramValue"];
        }
    }

    static fromJS(data: any): ChartLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["id"] = this.id;
        data["code"] = this.code;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["paramValue"] = this.paramValue;
        return data;
    }

    clone(): ChartLabelDto {
        const json = this.toJSON();
        let result = new ChartLabelDto();
        result.init(json);
        return result;
    }
}

export interface IChartLabelDto {
    label: string | undefined;
    id: string | undefined;
    code: string | undefined;
    startDateTime: Date | undefined;
    endDateTime: Date | undefined;
    dateTime: Date | undefined;
    paramValue: string | undefined;
}

export class AjaxResponseOfListOfChartDataResponseDto implements IAjaxResponseOfListOfChartDataResponseDto {
    result: ChartDataResponseDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfChartDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(ChartDataResponseDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfChartDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfChartDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfChartDataResponseDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfChartDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfChartDataResponseDto {
    result: ChartDataResponseDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class OrderFilterDto implements IOrderFilterDto {
    programId: string | undefined;
    selectedDate: Date | undefined;
    orderStatusIds: string[] | undefined;
    orderStatusRejectionReasonTypeId: string | undefined;

    constructor(data?: IOrderFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.selectedDate = _data["selectedDate"] ? new Date(_data["selectedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderStatusIds"])) {
                this.orderStatusIds = [] as any;
                for (let item of _data["orderStatusIds"])
                    this.orderStatusIds.push(item);
            }
            this.orderStatusRejectionReasonTypeId = _data["orderStatusRejectionReasonTypeId"];
        }
    }

    static fromJS(data: any): OrderFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["selectedDate"] = this.selectedDate ? this.selectedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orderStatusIds)) {
            data["orderStatusIds"] = [];
            for (let item of this.orderStatusIds)
                data["orderStatusIds"].push(item);
        }
        data["orderStatusRejectionReasonTypeId"] = this.orderStatusRejectionReasonTypeId;
        return data;
    }

    clone(): OrderFilterDto {
        const json = this.toJSON();
        let result = new OrderFilterDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFilterDto {
    programId: string | undefined;
    selectedDate: Date | undefined;
    orderStatusIds: string[] | undefined;
    orderStatusRejectionReasonTypeId: string | undefined;
}

export class AjaxResponseOfListOfSimpleOrderDto implements IAjaxResponseOfListOfSimpleOrderDto {
    result: SimpleOrderDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfSimpleOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(SimpleOrderDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfSimpleOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfSimpleOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfSimpleOrderDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfSimpleOrderDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfSimpleOrderDto {
    result: SimpleOrderDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class SimpleOrderDto implements ISimpleOrderDto {
    id: string | undefined;
    orderId: string | undefined;
    orderPassedThresholdDate: Date | undefined;
    orderStatusDate: Date | undefined;
    failedRules: string | undefined;

    constructor(data?: ISimpleOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.orderPassedThresholdDate = _data["orderPassedThresholdDate"] ? new Date(_data["orderPassedThresholdDate"].toString()) : <any>undefined;
            this.orderStatusDate = _data["orderStatusDate"] ? new Date(_data["orderStatusDate"].toString()) : <any>undefined;
            this.failedRules = _data["failedRules"];
        }
    }

    static fromJS(data: any): SimpleOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["orderPassedThresholdDate"] = this.orderPassedThresholdDate ? this.orderPassedThresholdDate.toISOString() : <any>undefined;
        data["orderStatusDate"] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
        data["failedRules"] = this.failedRules;
        return data;
    }

    clone(): SimpleOrderDto {
        const json = this.toJSON();
        let result = new SimpleOrderDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleOrderDto {
    id: string | undefined;
    orderId: string | undefined;
    orderPassedThresholdDate: Date | undefined;
    orderStatusDate: Date | undefined;
    failedRules: string | undefined;
}

export class DashboardCommunicationFilterDto implements IDashboardCommunicationFilterDto {
    communicationTypeIds: string[] | undefined;
    communicationDirection: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    documentStatus: string | undefined;
    programName: string | undefined;
    orderNumbers: string[] | undefined;

    constructor(data?: IDashboardCommunicationFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["communicationTypeIds"])) {
                this.communicationTypeIds = [] as any;
                for (let item of _data["communicationTypeIds"])
                    this.communicationTypeIds.push(item);
            }
            this.communicationDirection = _data["communicationDirection"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.documentStatus = _data["documentStatus"];
            this.programName = _data["programName"];
            if (Array.isArray(_data["orderNumbers"])) {
                this.orderNumbers = [] as any;
                for (let item of _data["orderNumbers"])
                    this.orderNumbers.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardCommunicationFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCommunicationFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.communicationTypeIds)) {
            data["communicationTypeIds"] = [];
            for (let item of this.communicationTypeIds)
                data["communicationTypeIds"].push(item);
        }
        data["communicationDirection"] = this.communicationDirection;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["documentStatus"] = this.documentStatus;
        data["programName"] = this.programName;
        if (Array.isArray(this.orderNumbers)) {
            data["orderNumbers"] = [];
            for (let item of this.orderNumbers)
                data["orderNumbers"].push(item);
        }
        return data;
    }

    clone(): DashboardCommunicationFilterDto {
        const json = this.toJSON();
        let result = new DashboardCommunicationFilterDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardCommunicationFilterDto {
    communicationTypeIds: string[] | undefined;
    communicationDirection: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    documentStatus: string | undefined;
    programName: string | undefined;
    orderNumbers: string[] | undefined;
}

export class AjaxResponseOfListOfDashboardCommunicationSummaryDto implements IAjaxResponseOfListOfDashboardCommunicationSummaryDto {
    result: DashboardCommunicationSummaryDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfDashboardCommunicationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(DashboardCommunicationSummaryDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfDashboardCommunicationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfDashboardCommunicationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfDashboardCommunicationSummaryDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfDashboardCommunicationSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfDashboardCommunicationSummaryDto {
    result: DashboardCommunicationSummaryDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class DashboardCommunicationSummaryDto implements IDashboardCommunicationSummaryDto {
    id: string | undefined;
    communicationDate: Date | undefined;
    communicationDirectionId: string | undefined;
    communicationStatusId: string | undefined;
    communicationTypeId: string | undefined;
    documentStatusId: string | undefined;
    documentStatusName: string | undefined;
    orderNumber: string | undefined;
    communicationNumber: string | undefined;

    constructor(data?: IDashboardCommunicationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationDate = _data["communicationDate"] ? new Date(_data["communicationDate"].toString()) : <any>undefined;
            this.communicationDirectionId = _data["communicationDirectionId"];
            this.communicationStatusId = _data["communicationStatusId"];
            this.communicationTypeId = _data["communicationTypeId"];
            this.documentStatusId = _data["documentStatusId"];
            this.documentStatusName = _data["documentStatusName"];
            this.orderNumber = _data["orderNumber"];
            this.communicationNumber = _data["communicationNumber"];
        }
    }

    static fromJS(data: any): DashboardCommunicationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCommunicationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationDate"] = this.communicationDate ? this.communicationDate.toISOString() : <any>undefined;
        data["communicationDirectionId"] = this.communicationDirectionId;
        data["communicationStatusId"] = this.communicationStatusId;
        data["communicationTypeId"] = this.communicationTypeId;
        data["documentStatusId"] = this.documentStatusId;
        data["documentStatusName"] = this.documentStatusName;
        data["orderNumber"] = this.orderNumber;
        data["communicationNumber"] = this.communicationNumber;
        return data;
    }

    clone(): DashboardCommunicationSummaryDto {
        const json = this.toJSON();
        let result = new DashboardCommunicationSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardCommunicationSummaryDto {
    id: string | undefined;
    communicationDate: Date | undefined;
    communicationDirectionId: string | undefined;
    communicationStatusId: string | undefined;
    communicationTypeId: string | undefined;
    documentStatusId: string | undefined;
    documentStatusName: string | undefined;
    orderNumber: string | undefined;
    communicationNumber: string | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}